module.exports = require("@web3auth/wallet-connect-v1-adapter");